import { useMemo } from 'react';
import { SettingsStore, ConfigStore, ZenJsUtils } from '@zen/common-app-parts';

/**
 * Get the FP contract id and address
 * @returns {{id: string, address: string, actions: {setId: (string) => string}}}
 */
export default function useContract() {
  const {
    state: {
      settings: { chain, id: cId },
    },
    actions,
  } = SettingsStore.useStore();
  const { contract, contracts } = ConfigStore.useStore();
  const id = cId || contract[chain];
  const setId = (id) => {
    actions.setSetting({ name: 'id', value: id });
  };
  const address = useMemo(() => ZenJsUtils.getContractAddress(chain, id), [chain, id]);

  return { id, address, contracts, actions: { setId } };
}
